var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Oops! The "+_vm._s(_vm.missing)+" you're looking for does not exist")]),_c('h3',[_vm._v(" Back to the "),_c('router-link',{attrs:{"to":"/events"}},[_vm._v("Events page")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }